import React, { useContext, useMemo } from "react";
import { Alert, Link as MuiLink, Typography } from "@mui/material";
import {
  BRAND_COLOR,
  KivuI18nContext,
  localizedPath,
  PAGE_ROUTE_ABOUT_PRODUCT,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

/**
 * Learn-more ingress at the top of the add-product form.
 */
const AddProductGuidanceBanner: React.FC = () => {
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  const aboutProductPath = useMemo(
    () =>
      language != null && defaultLang != null
        ? localizedPath(PAGE_ROUTE_ABOUT_PRODUCT, language, defaultLang)
        : `/${PAGE_ROUTE_ABOUT_PRODUCT}`,
    [language, defaultLang]
  );

  return (
    <Alert
      severity="info"
      data-testid="add-product-guidance-banner"
      sx={{
        borderRadius: 2,
        alignItems: "flex-start",
        "& .MuiAlert-message": { width: "100%" }
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {t(
          "add-product-guidance-prefix",
          "A product is your catalog listing; product items are the stock lines that hold quantities in each store."
        )}{" "}
        <MuiLink
          href={aboutProductPath}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{
            color: BRAND_COLOR,
            fontWeight: 600,
            "&:hover": { color: BRAND_COLOR }
          }}
          data-testid="add-product-guidance-about-product-link"
        >
          {t(
            "add-product-guidance-about-product-link",
            "Learn how products and product items work"
          )}
        </MuiLink>
      </Typography>
    </Alert>
  );
};

export default AddProductGuidanceBanner;
